import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

const initialState = {
  listProductTiki: null,
  isLoad: false,
};

export const getListProductTiki = createAsyncThunk(
  "Tiki/getListProductTiki",
  async (idweb) => {
    const response = await http.get(`/list-product-tiki?idw=${idweb}`);
    return response.data.data;
  }
);

const getProductTiki = createSlice({
  name: "getProductTiki",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getListProductTiki.pending, (state) => {
        state.isLoad = true;
      })
      .addCase(getListProductTiki.fulfilled, (state, action) => {
        state.listProductTiki = action.payload;
        state.isLoad = false;
      })
      .addCase(getListProductTiki.rejected, (state) => {
        state.isLoad = false;
      });
  },
});

export default getProductTiki.reducer;
